module.exports = __webpack_public_path__ + "static/media/gipsy_rome.3749fc53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/gipsy_rome.jpg
// module id = 448
// module chunks = 0